import React from "react";
import { Button } from "antd";
import SparkleIcon from "./SparkleIcon";
import { HELP_CHAT_OPEN_EVENT } from "../../utils/helpChatUtils";

const AskAIButton = ({ style }) => (
  <Button
    data-help-chat-inline
    className="ask-ai-inline"
    size="large"
    icon={
      <span style={{ color: "#1677ff", display: "inline-flex" }}>
        <SparkleIcon size={19} />
      </span>
    }
    onClick={() => window.dispatchEvent(new Event(HELP_CHAT_OPEN_EVENT))}
    style={style}
  >
    Ask AI
  </Button>
);

export default AskAIButton;
